import { render } from "./FormStep.vue?vue&type=template&id=072ebbeb&scoped=true"
import script from "./FormStep.vue?vue&type=script&lang=js"
export * from "./FormStep.vue?vue&type=script&lang=js"

import "./FormStep.vue?vue&type=style&index=0&id=072ebbeb&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-072ebbeb"]])

export default __exports__